var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { PageBlock } from '../page_block/PageBlock';
import { footerStyles, partnerStyles, poweredByStyles, providerStyles } from './SiteFooter.css';
export const Footer = React.forwardRef(function SiteFooter(_a, ref) {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (_jsx(PageBlock, Object.assign({ as: "footer", className: cx(footerStyles, className), ref: ref, withPaddingY: true }, rest, { children: children })));
});
const FooterSectionComponent = (_a) => {
    var { className, sectionStyles } = _a, rest = __rest(_a, ["className", "sectionStyles"]);
    return _jsx("div", Object.assign({ className: cx(sectionStyles, className) }, rest));
};
const PaymentProvidersWrapper = (props) => (_jsx(FooterSectionComponent, Object.assign({ sectionStyles: providerStyles }, props)));
const TrustedPartnersWrapper = (props) => (_jsx(FooterSectionComponent, Object.assign({ sectionStyles: partnerStyles }, props)));
const PoweredByWrapper = (props) => (_jsx(FooterSectionComponent, Object.assign({ sectionStyles: poweredByStyles }, props)));
export const SiteFooter = Footer;
SiteFooter.PaymentProviders = PaymentProvidersWrapper;
SiteFooter.PoweredBy = PoweredByWrapper;
SiteFooter.TrustedPartners = TrustedPartnersWrapper;
